export default __webpack_public_path__ + "static/media/8.101343a5.png";